import type { ReactNode } from "react";
import { HelpPopover } from "./HelpPopover";

// Selector de color = swatch nativo + input hex. Unifica el par color+text
// que estaba inline en GlobalSettings (Colores) y el ColorPickerRow de
// Configuracion (ruleta). El swatch lleva shrink-0 y el hex min-w-0 para que
// nunca se solapen en columnas angostas (el nit visual que marco el dueño).
export function ColorField({
  label,
  value,
  onChange,
  help,
}: {
  label: ReactNode;
  value: string;
  onChange: (v: string) => void;
  help?: ReactNode;
}) {
  return (
    <label className="flex flex-col gap-1 text-sm">
      <span className="flex items-center gap-1.5 opacity-80">
        {label}
        {help && <HelpPopover>{help}</HelpPopover>}
      </span>
      <div className="flex items-center gap-2">
        <input
          type="color"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="h-10 w-12 shrink-0 cursor-pointer rounded border border-white/10 bg-transparent p-0"
        />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="#rrggbb"
          className="min-w-0 flex-1 rounded-lg bg-white/10 px-3 py-2 font-mono text-sm outline-none focus:ring-2 focus:ring-[#a78bfa]"
        />
      </div>
    </label>
  );
}
